export default __webpack_public_path__ + "static/verification-7e24a2585bed3cfe3ce2e783221aaaee.png";